import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { UserService } from '@services/user.service';
import { ToastService } from '@utils/toast.service';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectItemGroup } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { CatalogService } from '@services/catalog.service';
import { SelectModule } from 'primeng/select';
import { PlaceholderCard } from '@components/placeholders/card/card.component';
import { DividerModule } from 'primeng/divider';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FieldsetModule } from 'primeng/fieldset';
import { TabViewModule } from 'primeng/tabview';
import { IUserSession, SessionService } from '@utils/session.service';

@Component({
  selector: 'app-user-create',
  imports: [
    CommonModule,
    FormsModule,
    BackboneComponent,
    BreadcrumbComponent,
    ReactiveFormsModule,
    InputTextModule,
    InputMaskModule,
    PasswordModule,
    ButtonModule,
    MultiSelectModule,
    InputNumberModule,
    SelectModule,
    PlaceholderCard,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    FieldsetModule,
    TabViewModule,
  ],
  templateUrl: './create.component.html',
  styleUrl: './create.component.scss',
})
export class UserCreatePage {
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private catalogService = inject(CatalogService);
  private toastService = inject(ToastService);
  private router = inject(Router);
  private sessionService = inject(SessionService);

  public isLoading = false;
  public isSaving = false;
  public Object = Object;

  public roles: any = [];
  public permissions!: SelectItemGroup[];
  public shareLimit: any = [];
  public status = [
    { label: 'Activo', value: 'ACTIVE' },
    { label: 'Inactivo', value: 'INACTIVE' },
  ];

  public formUser = this.formBuilder.group({
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    nickname: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
    password: [null, [Validators.required, Validators.minLength(8)]],
    rpassword: [null, [Validators.required, Validators.minLength(8)]],
    role: [null, Validators.required],
    permissions: [null],
    numberSessions: [null],
    prices: this.formBuilder.group({
      REGISTRO_CIVIL: this.formBuilder.group({
        DIGITALIZACION: [1, Validators.required],
        CORRECCION_ACTA: [1, Validators.required],
        MARCO_FOLIO_REVERSO: [1, Validators.required],
        BUSCAR_ACTO: this.formBuilder.group({
          AGUASCALIENTES: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          BAJA_CALIFORNIA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          BAJA_CALIFORNIA_SUR: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CAMPECHE: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          COAHUILA_DE_ZARAGOZA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          COLIMA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CHIAPAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CHIHUAHUA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CIUDAD_DE_MEXICO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          DURANGO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          GUANAJUATO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          GUERRERO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          HIDALGO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          JALISCO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MEXICO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MICHOACAN_DE_OCAMPO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MORELOS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          NAYARIT: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          NUEVO_LEON: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          OAXACA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          PUEBLA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          QUERETARO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          QUINTANA_ROO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SAN_LUIS_POTOSI: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SINALOA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SONORA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TABASCO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TAMAULIPAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TLAXCALA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          VERACRUZ: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          YUCATAN: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          ZACATECAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
        }),
      }),
      SAT: this.formBuilder.group({
        CAMBIO_EMISION: [1, Validators.required],
        CEDULA_IDENTIFICACION_FISCAL: [1, Validators.required],
        CITA_PERSONA_FISICA: [1, Validators.required],
        CONSTANCIA_SITUACION_FISCAL: [1, Validators.required],
        OPINION_CUMPLIMIENTO: [1, Validators.required],
        RECUPERACION_CFDI: [1, Validators.required],
        RECUPERACION_DECLARACION: [1, Validators.required],
        CITA_PERSONA_MORAL: [1, Validators.required],
        ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA: [1, Validators.required],
        ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA: [1, Validators.required],
        CONTRASENA_CIEC_INE: [1, Validators.required],
      }),
      IMSS: this.formBuilder.group({
        INFORMACION_NSS: [1, Validators.required],
        CONSULTAR_NSS: [1, Validators.required],
        ASIGNAR_CORREO_NSS: [1, Validators.required],
        SEMANAS_COTIZADAS: [1, Validators.required],
        VIGENCIA_DERECHO: [1, Validators.required],
        NO_DERECHOHABIENTE: [1, Validators.required],
      }),
      RENAPO: this.formBuilder.group({
        CURP: [1, Validators.required],
        CORRECCION_CURP: [1, Validators.required],
        UNIFICACION_CURP: [1, Validators.required],
        CERTIFICACION_CURP: [1, Validators.required],
      }),
      ISSSTE: this.formBuilder.group({
        TALON_PAGOS: [1, Validators.required],
        CONSTANCIA_ACREDITACION_NO_AFILIACION: [1, Validators.required],
      }),
      CFE: this.formBuilder.group({
        RECIBO_DE_LUZ: [1, Validators.required],
      }),
    }),
    numberSharesAllowed: this.formBuilder.group({
      REGISTRO_CIVIL_MARCOS_FOLIOS_REVERSOS: [0, Validators.required],
      REGISTRO_CIVIL_BUSCAR_ACTO: [0, Validators.required],
      REGISTRO_CIVIL_DIGITALIZATION: [0, Validators.required],
      REGISTRO_CIVIL_CORRECCION_ACTA: [0, Validators.required],

      SAT_CAMBIO_EMISION: [0, Validators.required],
      SAT_CONSTANCIA_SITUACION_FISCAL: [0, Validators.required],
      SAT_OPINION_CUMPLIMIENTO: [0, Validators.required],
      SAT_CEDULA_IDENTIFICACION_FISCAL: [0, Validators.required],
      SAT_RECUPERACION_CFDI: [0, Validators.required],
      SAT_RECUPERACION_DECLARACION: [0, Validators.required],
      SAT_CITA_PERSONA_FISICA: [0, Validators.required],
      SAT_CITA_PERSONA_MORAL: [0, Validators.required],
      SAT_ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA: [0, Validators.required],
      SAT_ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA: [0, Validators.required],
      SAT_CONTRASENA_CIEC_INE: [0, Validators.required],
      SAT_RESTABLECER_CONTRASENA: [0, Validators.required],

      IMSS_INFORMACION_NSS: [0, Validators.required],
      IMSS_CONSULTAR_NSS: [0, Validators.required],
      IMSS_ASIGNAR_CORREO_NSS: [0, Validators.required],
      IMSS_SEMANAS_COTIZADAS: [0, Validators.required],
      IMSS_VIGENCIA_DERECHO: [0, Validators.required],
      IMSS_NO_DERECHOHABIENTE: [0, Validators.required],

      RENAPO_CURP: [0, Validators.required],
      RENAPO_CORRECCION_CURP: [0, Validators.required],
      RENAPO_UNIFICACION_CURP: [0, Validators.required],
      RENAPO_CERTIFICACION_CURP: [0, Validators.required],

      ISSSTE_TALON_PAGOS: [0, Validators.required],
      ISSSTE_CONSTANCIA_ACREDITACION_AFILIACION: [0, Validators.required],

      CFE_RECIBO_DE_LUZ: [0, Validators.required],
    }),
  });

  async ngOnInit() {
    this.isLoading = true;

    this.userService.roles().then((response: any) => (this.roles = response));

    this.catalogService.getPermissionsList().then((response) => (this.permissions = response));

    let user: IUserSession | null = this.sessionService.getUser();

    if (user?.userId !== null) {
      this.userService.obtainShareLimit(Number(user?.userId)).then((response: any) => (this.shareLimit = response));
    }

    this.isLoading = false;
  }

  save = async () => {
    this.isSaving = true;

    await this.userService
      .create(this.formUser.value)
      .then(() => {
        this.toastService.success('Cuenta de usuario creada exitosamente.');
        this.router.navigate(['/user']);
      })
      .catch(() => this.toastService.error('Error al crear la cuenta de usuario.'));

    this.isSaving = false;
  };

  formatEstadoName(estado: string): string {
    const estadosMap: { [key: string]: string } = {
      AGUASCALIENTES: 'Aguascalientes',
      BAJA_CALIFORNIA: 'Baja California',
      BAJA_CALIFORNIA_SUR: 'Baja California Sur',
      CAMPECHE: 'Campeche',
      COAHUILA_DE_ZARAGOZA: 'Coahuila',
      COLIMA: 'Colima',
      CHIAPAS: 'Chiapas',
      CHIHUAHUA: 'Chihuahua',
      CIUDAD_DE_MEXICO: 'Ciudad de México',
      DURANGO: 'Durango',
      GUANAJUATO: 'Guanajuato',
      GUERRERO: 'Guerrero',
      HIDALGO: 'Hidalgo',
      JALISCO: 'Jalisco',
      MEXICO: 'México',
      MICHOACAN_DE_OCAMPO: 'Michoacán',
      MORELOS: 'Morelos',
      NAYARIT: 'Nayarit',
      NUEVO_LEON: 'Nuevo León',
      OAXACA: 'Oaxaca',
      PUEBLA: 'Puebla',
      QUERETARO: 'Querétaro',
      QUINTANA_ROO: 'Quintana Roo',
      SAN_LUIS_POTOSI: 'San Luis Potosí',
      SINALOA: 'Sinaloa',
      SONORA: 'Sonora',
      TABASCO: 'Tabasco',
      TAMAULIPAS: 'Tamaulipas',
      TLAXCALA: 'Tlaxcala',
      VERACRUZ: 'Veracruz',
      YUCATAN: 'Yucatán',
      ZACATECAS: 'Zacatecas',
    };

    return estadosMap[estado] || estado;
  }
}
